import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash';

import {
  Autocomplete, TextField, Chip, Paper,
} from '@mui/material';

import localization from '../../localization';

const AutocompleteWithChips = ({
  selectOptions,
  label,
  onChange,
  arrayValue,
  arrayTypeValue,
  isDisabled,
  getAdditionalOptions,
  curId,
  getOptionsValue,
  sx,
  alphabeticallySort,
}) => {
  const [curArrayOfObjects, setCurArrayOfObjects] = useState([]);
  const [additionalOptions, setAdditionalOptions] = useState([]);
  const [search, setSearch] = useState('');

  const handleSetAdditionalOptions = (optionsData) => {
    const newAddOpt = [...additionalOptions];
    const idsArray = additionalOptions.map((o) => o.id);
    const idsArrayOptionsDef = selectOptions.map((o) => o.id);

    optionsData.forEach((el) => {
      if (!idsArray.includes(el.id) && !idsArrayOptionsDef.includes(el.id) && curId !== el.id) {
        newAddOpt.push(el);
        idsArray.push(el.id);
      }
    });

    setAdditionalOptions(newAddOpt);
  };

  useEffect(() => {
    let timer;

    if (search && getAdditionalOptions) {
      timer = setTimeout(
        () => getAdditionalOptions(search).then((res) => {
          handleSetAdditionalOptions(res);
        }),
        300,
      );
    }

    return () => clearTimeout(timer);
  // TODO: Refactor this component to avoid the mistake below
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (selectOptions.length && arrayTypeValue) {
      if (!getAdditionalOptions) {
        setCurArrayOfObjects(arrayValue.map((it) => selectOptions.find((opt) => opt.id === it) ||
          { id: it, value: it }));
      } else {
        const notInOptionIds = [];
        const newCurArrayOfObjects = [];

        arrayValue.forEach((it) => {
          const option = selectOptions.find((opt) => opt.id === it) || additionalOptions.find((opt) => opt.id === it);

          if (option) {
            newCurArrayOfObjects.push(option);
          } else {
            notInOptionIds.push(it);
          }
        });

        if (notInOptionIds.length) {
          const requestArray = [];
          notInOptionIds.forEach((id) => {
            if (getOptionsValue) {
              requestArray.push(getOptionsValue(id));
            } else {
              requestArray.push(getAdditionalOptions(id));
            }
          });

          Promise.allSettled(requestArray)
            .then((res) => {
              const newAdOpt = [];
              const currentAdditional = [];

              res.forEach((o, index) => {
                if (!o.value.length) {
                  newAdOpt.push({ id: notInOptionIds[index], value: `!!${notInOptionIds[index]}!!` });
                }

                newAdOpt.push(...o.value);
              });
              notInOptionIds.forEach((id) => {
                currentAdditional.push(newAdOpt.find((it) => it.id === id));
              });

              setCurArrayOfObjects([...newCurArrayOfObjects, ...currentAdditional]);
              handleSetAdditionalOptions(newAdOpt);
            });
        } else {
          setCurArrayOfObjects(newCurArrayOfObjects);
          handleSetAdditionalOptions(additionalOptions);
        }
      }
    } else if (selectOptions.length) {
      setCurArrayOfObjects([...arrayValue]);
    }
  // TODO: Refactor this component to avoid the mistake below
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayValue, selectOptions]);

  const getOptionLabel = (option) => {
    const lastBracketIndex = typeof option?.value === 'string' ? option?.value?.lastIndexOf('(') : -1;

    if (lastBracketIndex > 0) {
      // remove option id in the option label like "option name (option id)"
      return `${option?.value}`.substring(0, lastBracketIndex).trim();
    }

    return option?.value || option?.toString();
  };

  return (
    <Autocomplete
      sx={sx}
      fullWidth
      disabled={isDisabled}
      PaperComponent={({ children }) => (
        <Paper style={{ marginBottom: 10 }}>{children}</Paper>
      )}
      isOptionEqualToValue={(option, value) => option.id === value?.id || option.id === value}
      getOptionLabel={(option) => option?.value || ''}
      onChange={(e, newValue) => (arrayTypeValue ? onChange(newValue.map((val) => val.id))
        : onChange(newValue))}
      value={alphabeticallySort ? curArrayOfObjects.sort((a, b) =>
        a.value.toLowerCase().localeCompare(b.value.toLowerCase())
      ) : curArrayOfObjects}
      multiple
      id="tags-filled"
      options={uniqBy([...selectOptions, ...additionalOptions], 'id')}
      clearOnBlur
      renderTags={(value, getTagProps) => value?.map((option, index) => (
        <Chip
          key={option?.value || option}
          variant="outlined"
          label={getOptionLabel(option)}
          {...getTagProps({ index })}
        />
      ))}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          {...params}
          variant="outlined"
          label={localization.t(`labels.${label}`)}
        />
      )}
    />
  );
};

AutocompleteWithChips.propTypes = {
  optionLabelKey: PropTypes.string,
  label: PropTypes.string,
  arrayValue: PropTypes.array,
  selectOptions: PropTypes.array,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  arrayTypeValue: PropTypes.bool,
  getAdditionalOptions: PropTypes.func,
  curId: PropTypes.string,
  getOptionsValue: PropTypes.func,
  alphabeticallySort: PropTypes.bool,
};

AutocompleteWithChips.defaultProps = {
  arrayValue: [],
};

export default AutocompleteWithChips;
